import { render } from "./UserInvites.vue?vue&type=template&id=322635fd&scoped=true"
import script from "./UserInvites.vue?vue&type=script&lang=js"
export * from "./UserInvites.vue?vue&type=script&lang=js"

import "./UserInvites.vue?vue&type=style&index=0&id=322635fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322635fd"]])

export default __exports__